import { useState } from 'react';
import { Button } from 'react-bootstrap';
import styles from './style.module.scss';
import { MoreIcon, VoucherValueIcon } from '../../../assets/Icon';
import BuyVoucherModal from '../../dialogs/buy-voucher-dialog';

type VoucherCardProps = {
  image: string;
  title: string;
  value: number;
};
const VoucherCard = ({ image, title, value }: VoucherCardProps) => {
  const [buyVoucherModal, setBuyVoucherModal] = useState(false);
  return (
    <>
      <BuyVoucherModal
        open={buyVoucherModal}
        onClose={() => setBuyVoucherModal(false)}
      />
      <div className={styles.voucherCard}>
        <div className="text-end mb-2">
          <MoreIcon />
        </div>
        <div className={styles.voucherContent}>
          <div className={styles.iconbg}>
            <img src={image} alt="voucher-image" />
          </div>
          <div>
            <span className={styles.voucherTitle}>{title}</span>
            <p className={styles.voucherValue}>
              Value: <VoucherValueIcon size={16} /> <strong>{value}</strong>
            </p>
            <Button onClick={() => setBuyVoucherModal(true)}>
              Buy Voucher
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default VoucherCard;
